// extracted by mini-css-extract-plugin
export default {"modalHeader":"styles_modalHeader__QGO9U","modalHeader_icon":"styles_modalHeader_icon__Z1z8q","modalHeader_title":"styles_modalHeader_title__1yT7j"};